import { Component, OnInit, Inject } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {NS_AccountCommonDialog, NS_Enums, subscriptionDocumentationLink} from 'src/app/shared/namespaces';
@Component({
  selector: 'app-account-common-dialog',
  templateUrl: './account-common-dialog.component.html',
  styleUrls: ['./account-common-dialog.component.scss']
})
export class AccountCommonDialogComponent implements OnInit {
  callbackNameEnum = NS_Enums.callbackNameEnum;
  popupTypeEnum = NS_AccountCommonDialog.popupTypeEnum;
  dialogResultTypeEnum = NS_AccountCommonDialog.dialogResultTypeEnum;

  constructor(private thisDialogRef: MatDialogRef<AccountCommonDialogComponent>,
  @Inject(MAT_DIALOG_DATA) public data: any) { }

  onInit = false;

  ngOnInit(): void {
    this.onInit = true;
  }  

  onCloseAccountDialog(buttonData) {
    if(buttonData.type == NS_AccountCommonDialog.dialogResultTypeEnum.ok){
      this.thisDialogRef.close(NS_AccountCommonDialog.dialogResultTypeEnum.ok);
    } else{
      this.thisDialogRef.close(NS_AccountCommonDialog.dialogResultTypeEnum.cancel);
    }
    
  }

  openUpgradeDocumentation(){
    window.open(subscriptionDocumentationLink, '_blank');
  }

}
